/**
 * Carga de una entrada del léxico Strong para la CONCORDANCIA, OFFLINE-FIRST.
 *
 * Lee la entrada sembrada localmente (`strong_entry`, marcada `localOnly`) por su
 * número Strong canónico (p. ej. "H7225", "G3056"). Funciona sin red ni servidor;
 * es la fuente del MVP offline de la concordancia.
 */

import { eq, type PowerSyncDrizzleDB, strong_entry, type StrongEntry } from "@bso/powersync";

export type StrongEntryView = Pick<
  StrongEntry,
  "code" | "lemma" | "transliteration" | "pronunciation" | "gloss" | "definition" | "language"
>;

/**
 * Lee la entrada Strong desde la base local. Devuelve `null` si el código no está
 * sembrado (el llamador puede caer a Tauri/HTTP para léxico fuera de la semilla).
 */
export async function loadStrongEntryFromLocal(
  db: PowerSyncDrizzleDB | null,
  code: string,
): Promise<StrongEntryView | null> {
  if (!db || !code) {
    return null;
  }
  const normalized = code.toUpperCase();
  const rows = await db
    .select({
      code: strong_entry.code,
      lemma: strong_entry.lemma,
      transliteration: strong_entry.transliteration,
      pronunciation: strong_entry.pronunciation,
      gloss: strong_entry.gloss,
      definition: strong_entry.definition,
      language: strong_entry.language,
    })
    .from(strong_entry)
    .where(eq(strong_entry.code, normalized))
    .limit(1);

  return rows[0] ?? null;
}
